import API from "../../Common/API";

export const VISITORS_API_URL = `${API.getBaseUrl()}visitors/`;

export const MODULE_TAGNAME = 'visitors';
export const MANAGEMENT_PAGE = 'management';
export const ACTIVITY_PAGE = 'activity';
export const BOOKING_PAGE = 'booking';

export const MANAGEMENT_TYPE = {
    UPCOMING: 'upcoming',
    PAST: 'past',
}

export const ACTIVITY_TYPE = {
    SIGNED_IN: 'signed-in',
    SIGNED_OUT: 'signed-out',
    ALL: 'all'
}

export const BOOKING_TYPE = {
    WALK_IN: 'walk-in',
    SINGLE: 'single',
    GROUP: 'group',
}

export const STATUS = {
    DUE_TODAY: 'due',
    SIGNED_IN: 'signed-in',
    SIGNED_OUT: 'signed-out',
    ARCHIVED: 'archived',
    NO_SHOW: 'no-show',
}

// These constants should probably be renamed VISITORS instead of BOOKINGS
// to avoid ambiguity with the new bookings module
export const URL = {
    BOOKINGS: `/visitors/index`,
    BOOKINGS_ACTIVE: `/visitors/index/${MANAGEMENT_TYPE.UPCOMING}`,
    BOOKINGS_ARCHIVED: `/visitors/index/${MANAGEMENT_TYPE.PAST}`,

    LOGS: `/visitors/${ACTIVITY_PAGE}`,
    LOGS_ALL: `/visitors/${ACTIVITY_PAGE}/${ACTIVITY_TYPE.ALL}`,
    LOGS_SIGNED_IN: `/visitors/${ACTIVITY_PAGE}/${ACTIVITY_TYPE.SIGNED_IN}`,
    LOGS_SIGNED_OUT: `/visitors/${ACTIVITY_PAGE}/${ACTIVITY_TYPE.SIGNED_OUT}`,

    CREATE_BOOKING: `/visitors/bookings/create`,
    CREATE_BOOKING_SINGLE: `/visitors/bookings/create/single`,
    CREATE_BOOKING_GROUP: `/visitors/bookings/create/group`,
    CREATE_BOOKING_WALKIN: `/visitors/bookings/create/walk-in`,
}


export const MODAL = {
    SCAN_BARCODE: 'scanBarcode',
    SHOW_VISITOR: 'showVisitor',
    RETURN_VISITOR_PASS: 'returnVisitorPass',
}
